module.exports = __webpack_public_path__ + "static/media/sd.static.93fa1960.svg";